// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2bfS_","title":"ClientInsurance_title__3O6_T","itemText":"ClientInsurance_itemText__Gu-Ip"};